// Libraries
import axios from "utils/axios";

// Function to retry a failed request
const retryFailedRequest = async (url, data, method = "post") => {
  const axiosMethods = {
    get: axios.get,
    put: axios.put,
    post: axios.post,
  };
  return axiosMethods[method]?.(url, data);
};

// Generic query handler
const handleQuery = (method, url, data) => {
  return retryFailedRequest(url, data, method);
};

// Exported API functions
export const getQuery = (url, data) => handleQuery("get", url, data);

export const putQuery = (url, data) => handleQuery("put", url, data);

export const postQuery = (url, data) => handleQuery("post", url, data);
